<script setup lang="ts">
// components
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';

/********************
 * COMPOSITIONS      *
 ********************/
const contentService = useContentService();
const localePath = useLocalePath();
const { dynamicHeadline } = useDynamicHeadline();
const { fetchError } = useFetchError();
const { locale } = useI18n();

/********************
 * INITIALIZATION    *
 ********************/
const { data, pending } = await useLazyAsyncData('topic', async () => {
  try {
    const response = await contentService.getPagesByPrefix({ lang: locale.value, prefix: 'topic' });
    const pages = response.map(item => ({
      title: item.title,
      route: localePath({ path: item.url.replace(/\/$/, '') }),
    }));

    return {
      pages,
    };
  } catch (e) {
    fetchError(e);
  }
});
</script>

<template>
  <div class="link-list col-12 col-md-8 offset-md-2 py-6 md:py-12">
    <div class="container">
      <h1
        v-if="dynamicHeadline && !pending"
        class="mb-12 text-center"
      >
        {{ dynamicHeadline }}
      </h1>
      <CiLinkList
        v-if="!pending"
        :links="data?.pages"
        :key-to-sort="'title'"
        grid-classes="col-12 col-md-6"
      />
      <template v-else>
        <CiSkeletonItem class="mb-12 h-[50px]" />
        <CiSkeletonItem class="mb-6 h-[400px]" />
        <CiSkeletonItem class="mb-6 h-[400px]" />
      </template>
    </div>
  </div>
</template>

<style></style>
